module.exports = __webpack_public_path__ + "img/minted_invitees.88f991c0.svg";